"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSystemFieldsSlugs = exports.emptyDoc = exports.FieldCategories = exports.FieldGroups = exports.hiddenFields = exports.dateFields = exports.allFieldTypes = void 0;
exports.allFieldTypes = [
    "recordtitlefield",
    "textfield",
    "textnestedfield",
    "emailfield",
    "addressfield",
    "textareafield",
    "richtextareafield",
    "linkfield",
    "phonefield",
    "recordidfield",
    "colorpickerfield",
    "checklistfield",
    "datefield",
    "daterangefield",
    "durationfield",
    "duedatefield",
    "timetrackingfield",
    "multipleselectfield",
    "singleselectfield",
    "statusfield",
    "tagsfield",
    "yesnofield",
    "ipaddressfield",
    "dependencyfield",
    "dependencyrelationfield",
    "linkedrecordfield",
    "userfield",
    "subitemsfield",
    "buttonfield",
    "filefield",
    "signaturefield",
    "unknownfield",
    "numberfield",
    "currencyfield",
    "percentfield",
    "percentcompletefield",
    "autonumberfield",
    "countfield",
    "votefield",
    "numbersliderfield",
    "formulafield",
    "commentscountfield",
    "ratingfield",
    "availabilitystatusfield",
    "socialnetworkfield",
    "timefield",
    "firstcreatedfield",
    "lastupdatedfield",
    "rollupfield",
    "lookupfield",
    "fullnamefield",
];
exports.dateFields = ["datefield"];
exports.hiddenFields = ["availabilitystatusfield"];
exports.FieldGroups = {
    text: 1,
    selection: 2,
    datetime: 3,
    numeric: 4,
    file: 5,
    reference: 6,
    calculation: 7,
};
exports.FieldCategories = {
    basic: 1,
    essentials: 2,
    collaboration: 3,
    advanced: 4,
};
exports.emptyDoc = {
    type: "doc",
    content: [],
};
exports.defaultSystemFieldsSlugs = [
    "deleted_date",
    "followed_by",
    "first_created",
    "last_updated",
    "comments_count",
    "autonumber",
];
